import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LocaleTrans } from "../../types/locale";
import { arrayEquals } from "../../components/Utils";
import { useEffect, useState } from "react";
export function DropDownFilter({ id, label, items, values, valueChanged, }) {
    const [checked, setChecked] = useState([]);
    const [openFiltr, setOpenFiltr] = useState(false);
    items.sort();
    function checkboxChanged(value, isChecked) {
        if (isChecked) {
            setChecked([...checked, value]);
        }
        else {
            setChecked(checked.filter(check => check !== value));
        }
    }
    useEffect(() => {
        if (!values || arrayEquals(values, checked)) {
            return;
        }
        setChecked(values);
    }, [values]);
    useEffect(() => {
        if (checked.length > 0) {
            setOpenFiltr(true);
        }
        valueChanged?.(checked);
    }, [checked]);
    return (_jsxs("div", { className: openFiltr ? "car-filtr__group car-filtr__group--open" : "car-filtr__group", children: [_jsxs("div", { className: "car-filtr__sub", onClick: () => setOpenFiltr(!openFiltr), children: [_jsx("div", { className: "car-filtr__sub-title", children: label }), _jsx("span", { className: "car-filtr__sub-icon" })] }), _jsx("ul", { className: "car-filtr__list", children: items.map(item => _jsxs("li", { className: "car-filtr__list-item", children: [_jsx("input", { id: item, name: id, type: "checkbox", value: item, checked: checked.includes(item), onChange: ($event) => checkboxChanged($event.target.value, $event.target.checked) }), _jsx("label", { className: "car-filtr__checkbox-label", htmlFor: item, children: LocaleTrans[item] ?? item })] }, item)) })] }));
}
